// export const appVersion = '26.01.1'
export const appVersion = process.env.REACT_APP_VERSION